import React from 'react';
import TabContainer from '../../components/TabContainer';
import BirlesikMalKabulPage from '../grn/BirlesikMalKabulPage';
import StokDurumuPage from '../stok/StokDurumuPage';
import StokSayimPage from '../stok/StokSayimPage';
import StokSayimGecmisPage from '../stok/StokSayimGecmisPage';
import ZayiGirisiPage from '../stok/ZayiGirisiPage';
import PersonelYemegiPage from '../stok/PersonelYemegiPage';
// Pasife alındı 2026-05-01: TransferKarlilikPage — şirketler arası transfer kârlılığı
// import TransferKarlilikPage from '../stok/TransferKarlilikPage';
import InventoryPage from '../InventoryPage';

const StokDepoPage = () => {
  const tabs = [
    { id: 'stok-durumu', label: 'Stok', icon: '📦', component: <StokDurumuPage /> },
    { id: 'inventory', label: 'Transfer', icon: '🚚', component: <InventoryPage /> },
    // Pasife alındı 2026-05-01:
    // { id: 'karlilik', label: 'Karlılık', icon: '💸', component: <TransferKarlilikPage embedded={true} /> },
    { id: 'mal-kabul', label: 'Mal Kabul', icon: '📋', component: <BirlesikMalKabulPage /> },
    { id: 'stok-sayim', label: 'Sayım', icon: '📊', component: <StokSayimPage /> },
    { id: 'sayim-gecmis', label: 'Sayım Geçmişi', icon: '📅', component: <StokSayimGecmisPage /> },
    { id: 'zayi-girisi', label: 'Zayi', icon: '🗑️', component: <ZayiGirisiPage /> },
    { id: 'personel-yemegi', label: 'Personel Yemeği', icon: '🍽️', component: <PersonelYemegiPage /> },
  ];
  return <TabContainer title="Stok & Depo" tabs={tabs} defaultTab="stok-durumu" />;
};

export default StokDepoPage;
